import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/agendamento-exame-retroativo`

    return {
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        show(id) {

            return repository.get(`${baseUrl}/${id}`)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
        getJornadas(queryParms) {

            return repository.get(`${baseUrl}/jornada?${urlUtil.serialize(queryParms)}`)
        },
        getSupervisor(queryParms) {

            return repository.get(`${baseUrl}/supervisor?${urlUtil.serialize(queryParms)}`)
        },
        getCotas(queryParms) {

            return repository.get(`${baseUrl}/cota?${urlUtil.serialize(queryParms)}`)
        },
        getAgendamento(id) {

            return repository.get(`${baseUrl}/agendamento/${id}`)
        },
        getDetalhamento(id) {

            return repository.get(`${baseUrl}/detalhamento/${id}`)
        },
        printEtiqueta(id) {

            return repository.get(`${baseUrl}/etiqueta/${id}`)
        },
        printProtocolo(id) {

            return repository.get(`${baseUrl}/protocolo/${id}`)
        },
        getHistoricoMedicamento(id) {

            return repository.get(`${baseUrl}/historico-medicamento/${id}`)
        },
    }
}